/* jshint esnext:true */

export const adform = {
    rectangleSK: {
        bidder: 'adform',
        params: {
            mid: '292756',
        },
    },
    rectangleCZ: {
        bidder: 'adform',
        params: {
            mid: '257169',
        },
    },
    halfpageSK: {
        bidder: 'adform',
        params: {
            mid: '310187',
        },
    },
    halfpageCZ: {
        bidder: 'adform',
        params: {
            mid: '310186',
        },
    },
    billboardSK: {
        bidder: 'adform',
        params: {
            mid: '310178',
        },
    },
    billboardCZ: {
        bidder: 'adform',
        params: {
            mid: '310182',
        },
    },
    brandingDesktopSK: {
        bidder: 'adform',
        params: {
            mid: '354654',
        },
    },
    brandingDesktopCZ: {
        bidder: 'adform',
        params: {
            mid: '370360',
        },
    },
    brandingMobileSK: {
        bidder: 'adform',
        params: {
            mid: '370408',
        },
    },
    brandingMobileCZ: {
        bidder: 'adform',
        params: {
            mid: '370407',
        },
    },
};

// bidder of Etarget - Rubicon
// export const etarget = {
//     rectangleSK: {
//         bidder: 'rubicon',
//         params: {
//             accountId: '11352',
//             siteId: '118366',
//             zoneId: '590826',
//             sizes: [16],  // 16 = 336x280
//         },
//     },
//     rectangleCZ: {
//         bidder: 'rubicon',
//         params: {
//             accountId: '11352',
//             siteId: '125742',
//             zoneId: '594764',
//             sizes: [16],  // 16 = 336x280
//         },
//     },
// };

// bidder od Programmatic - AppNexus
// export const appnexus = {
//     rectangleSK: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '10479095',
//         },
//     },
//     rectangleCZ: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '10479529',
//         },
//     },
//     halfpageSK: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '10479094',
//         },
//     },
//     halfpageCZ: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '7196447',
//         },
//     },
//     billboardSK: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '10479096',
//         },
//     },
//     billboardCZ: {
//         bidder: 'appnexus',
//         params: {
//             placementId: '10479093',
//         },
//     },
// };

// bidder od Programmatic.cz
// export const admeta = {
//     rectangleSK: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98281169,
//         },
//     },
//     rectangleCZ: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98280890,
//         },
//     },
//     halfpageSK: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98281170,
//         },
//     },
//     halfpageCZ: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98280891,
//         },
//     },
//     billboardSK: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98281171,
//         },
//     },
//     billboardCZ: {
//         bidder: 'wideorbit',
//         params: {
//             pbId: 589,
//             pId: 98280892,
//         },
//     },
// };

export const criteo = {
    rectangleSK: {
        bidder: 'criteo',
        params: {
            // zoneId: 647144,  // API
            zoneId: 625655,  // Display
        },
    },
    rectangleCZ: {
        bidder: 'criteo',
        params: {
            // zoneId: 647143, // API
            zoneId: 625654,  // Display
        },
    },
};

export const test = {
    billboardSK: {
        bidder: 'adform',
        params: {
            mid: '427490',
        },
    },
};
